var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 19.5417H9.66659M13.3333 27.375H9.66659M24.3333 11.7083H9.66659M31.6666 11.3167V31.6833C31.6666 34.9736 31.6666 36.6188 31.0671 37.8755C30.5398 38.981 29.6984 39.8797 28.6635 40.443C27.487 41.0833 25.9469 41.0833 22.8666 41.0833H11.1333C8.05296 41.0833 6.51282 41.0833 5.3363 40.443C4.30141 39.8797 3.46002 38.981 2.93272 37.8755C2.33325 36.6188 2.33325 34.9736 2.33325 31.6833V11.3167C2.33325 8.02636 2.33325 6.38121 2.93272 5.12448C3.46002 4.01903 4.30141 3.12026 5.3363 2.55701C6.51282 1.91667 8.05296 1.91667 11.1333 1.91667H22.8666C25.9469 1.91667 27.487 1.91667 28.6635 2.55701C29.6984 3.12026 30.5398 4.01903 31.0671 5.12448C31.6666 6.38121 31.6666 8.02636 31.6666 11.3167Z",
    stroke: "#2B3D4F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ee182864787251091a137b3769904d42.svg";
export { ForwardRef as ReactComponent };